import type { EntryName } from "../config/client";
import { type UniversalBootstrapOpts } from "../universalBootstrap";

const ENGAGE_BOOTSTRAP_OPTS: UniversalBootstrapOpts = {
  projectIdHeader: true,
  googleTagManager: true,
  exceptionMonitoring: true,
  messageMediaThemes: false,
  patchRequestsWithAuth: true,
  requireCriticalBrowserSupport: true,
  rudderstack: false,
  setDefaultLanguageToBrowserDefault: false,
  extraNectaryTheme: null,
  withoutShadowRoot: false,
  handleUtmParameters: false,
};

const MM_BOOTSTRAP_OPTS: UniversalBootstrapOpts = {
  projectIdHeader: false,
  googleTagManager: true,
  exceptionMonitoring: true,
  messageMediaThemes: true,
  patchRequestsWithAuth: false,
  requireCriticalBrowserSupport: false,
  rudderstack: true,
  setDefaultLanguageToBrowserDefault: true,
  extraNectaryTheme: "message-media",
  withoutShadowRoot: true,
  handleUtmParameters: true,
};

const COP_BOOTSTRAP_OPTS: UniversalBootstrapOpts = {
  projectIdHeader: false,
  googleTagManager: false,
  exceptionMonitoring: false,
  messageMediaThemes: false,
  patchRequestsWithAuth: false,
  requireCriticalBrowserSupport: true,
  rudderstack: false,
  setDefaultLanguageToBrowserDefault: false,
  extraNectaryTheme: null,
  withoutShadowRoot: false,
  handleUtmParameters: false,
};

const MY_BOOTSTRAP_OPTS: UniversalBootstrapOpts = {
  projectIdHeader: false,
  googleTagManager: true,
  exceptionMonitoring: true,
  messageMediaThemes: false,
  patchRequestsWithAuth: false,
  requireCriticalBrowserSupport: true,
  rudderstack: false,
  setDefaultLanguageToBrowserDefault: false,
  extraNectaryTheme: null,
  withoutShadowRoot: false,
  handleUtmParameters: false,
};

export const UNIVERSAL_BOOTSTRAP_OPTIONS_BY_PORTAL = {
  engage: ENGAGE_BOOTSTRAP_OPTS,
  mm: MM_BOOTSTRAP_OPTS,
  cop: COP_BOOTSTRAP_OPTS,
  my: MY_BOOTSTRAP_OPTS,
} as const satisfies { [K in EntryName]: UniversalBootstrapOpts };
